<template>
  <fragment>
    <v-container fluid pa-0>
      <CButton
              v-if="input.length === 0 && !isShowMode"
              class="ma-3"
              outlined
              small
              fab
              color="accent"
              @click="() => onAddContent(input)"
      >
        <v-icon>add</v-icon>
      </CButton>
      <v-layout justify-center column fill-height>
        <template v-for="(content, index) in input">
          <v-layout :key="index" row fill-height :style="multi ? '' : 'margin-left:34px'">
            <v-flex shrink v-if="!isShowMode">
              <v-layout column fill-height>
                <v-flex grow :style="(index === input.length - 1) ? 'min-height: 40px;' : ''">
                </v-flex>
                <v-flex shrink>
                  <CButton
                    v-if="(index === input.length - 1) && input.length < 5 && multi"
                    class="ma-3"
                    small
                    fab
                    color="accent"
                    @click="() => onAddContent(input)"
                  >
                    <v-icon>add</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex shrink :style="(index === input.length - 1) ? 'margin-left: -30px' : 'margin-left:34px'">
              <ImageField
                      v-model="input[index]"
                :mode="mode"
                :index="index"
                :name="'images_' + index"
                label="画像"
                remarks=""
                :rules="required ? 'required' : ''"
                :updateThumbnail = updateThumbnail
                      :thumbnail = thumbnailList[index]
              />
            </v-flex>
            <template v-if="imageMain">
              <v-flex>
                <slot
                  v-if="input[index]"
                  name="image_main"
                  :input.sync="input[index]"
                />
              </v-flex>
            </template>
            <v-flex shrink >
              <v-layout column fill-height>
                <v-flex grow>
                  <CButton
                          color="red"
                          class="ma-3"
                          small
                          fab
                          dark
                          @click="() => onDeleteContent(input, index)"
                  >
                    <v-icon>clear</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import ImageField from "./images-imput";
import utility from "../../utility";

export default {
  components: {
    ImageField
  },
  props: {
    input: {
      type: Array,
      default: () => []
    },
    resourceName: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: "edit",
      validator: value => ["show", "create", "edit"].indexOf(value) !== -1
    },
    required: {
      type: Boolean,
      default: false
    },
    imageMain: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      thumbnailList: []
    };
  },
  watch: {
    "input": {
      handler(files) {
        if(this.input.length > 1 && this.input[this.input.length - 1] !== "") {
          name = this.getFileName(files[files.length - 1]);
          if (this.input.some((file, index) => {
            return (index !== this.input.length - 1) && (this.getFileName(file) === name);
          })) {
            utility.$alert("すでに同じファイル名の画像がアップロードされています", "", {
              type: "warning",
              center: false,
              dangerouslyUseHTMLString:true,
              confirmButtonText: '閉じる'
            });

            this.input.splice(this.input.length - 1, 1);
          }
        }
      },
      deep: true
    }
  },
  computed: {
    isShowMode() {
      return this.mode === "show";
    },
    isCreateMode() {
      return this.mode === "create";
    },
    isEditMode() {
      return this.mode === "edit";
    }
  },
  methods: {
    isString(value){
      return typeof (value) === 'string' || value instanceof String ;
    },
    getFileName(value){
       if (!this.isString(value)) {
        value = value['fileName'];
      }else{
        value = value.split("/").reverse()[0];
      }
      return value;
    },
    onAddContent(input) {
      let initEntity = "";

      if(input.length < 5 && input[input.length - 1] !== "") {
        input.push(initEntity);
        this.thumbnailList.push(null);
      }
    },
    onDeleteContent(input, index) {
      input.splice(index, 1);
      this.thumbnailList.splice(index, 1);
      if(input.length === 0) {
        this.onAddContent(input);
      }
    },
    updateThumbnail(index, file){
      this.thumbnailList[index] = URL.createObjectURL(file);
    }
  },
  created(){
    this.thumbnailList = [];
    this.input.forEach((i) => {
      this.thumbnailList.push(null);
    });
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
